// askSmart-ui/src/pages/TOSP/components/TenantContactPicker.tsx
import React, { useEffect, useState } from "react";
import { fetchTenantContacts, TenantContact } from "../tenantContacts";

interface TenantContactPickerProps {
  /** The × and Cancel do the same thing — leave without adding a tenant. */
  onClose: () => void;
  onNext: (contact: TenantContact) => void;
}

// Step 1: who the tenant is, from the users assigned the Tenant template in
// SMRT Docs.
export default function TenantContactPicker({
  onClose,
  onNext,
}: TenantContactPickerProps) {
  const [contacts, setContacts] = useState<TenantContact[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [chosen, setChosen] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchTenantContacts().then((result) => {
      if (cancelled) return;
      if (result.status === "error") setError(result.reason);
      else setContacts(result.contacts);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const selected = contacts.find((contact) => contact.userId === chosen);

  return (
    <>
      <div className="smrtdocs-modal-header tosp-wizard-header">
        <h2 style={{ margin: 0, fontSize: "1rem" }}>Add Tenant</h2>
        <button
          type="button"
          className="tosp-wizard-close"
          aria-label="Cancel"
          title="Cancel"
          onClick={onClose}
        >
          ×
        </button>
      </div>

      <div className="smrtdocs-modal-body">
        <div className="tosp-field">
          <label className="tosp-label" htmlFor="tosp-wizard-contact">
            Tenant
          </label>
          <select
            id="tosp-wizard-contact"
            className="manage-input"
            disabled={loading || !!error}
            value={chosen}
            onChange={(e) => setChosen(e.target.value)}
          >
            <option value="">
              {loading ? "Loading…" : "— Select a tenant —"}
            </option>
            {contacts.map((contact) => (
              <option key={contact.userId} value={contact.userId}>
                {contact.name || contact.email}
              </option>
            ))}
          </select>
          {error && <p className="tosp-field-error">{error}</p>}
        </div>
      </div>

      <div className="tosp-wizard-actions">
        <button type="button" className="btn-cancel" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="tosp-wizard-next"
          disabled={!selected}
          onClick={() => selected && onNext(selected)}
        >
          Next
        </button>
      </div>
    </>
  );
}
